module.exports = __webpack_public_path__ + "img/6.103db628.png";